if (!customElements.get('x-tabs')) {
  class Tabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('x-tab');
    }

    changeTab(selectedTab) {
      this.tabs.forEach(tab => (tab === selectedTab ? tab.show() : tab.hide()));
    }
  }

  customElements.define('x-tabs', Tabs);

  class Tab extends HTMLElement {
    constructor() {
      super();
      this.parent = this.closest('x-tabs');
      this.content = document.getElementById(
        this.getAttribute('aria-controls')
      );
      this.handleClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    isVisible() {
      return this.getAttribute('aria-selected') === 'true';
    }

    onClick() {
      this.parent.changeTab(this);
    }

    show() {
      this.setAttribute('aria-selected', true);
      this.content.setAttribute('aria-hidden', false);
    }

    hide() {
      this.setAttribute('aria-selected', false);
      this.content.setAttribute('aria-hidden', true);
    }

    toggle() {
      this.isVisible() ? this.hide() : this.show();
    }
  }

  customElements.define('x-tab', Tab);
}
